"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
const startCase_1 = __importDefault(require("lodash/startCase"));
const FeatureStatus_1 = __importDefault(require("../FeatureStatus"));
/**
 * Features
 */
class Feature {
    constructor(o = {}) {
        this.name = '';
        this.state = FeatureStatus_1.default.DISABLED;
        Object.assign(this, o);
    }
    get nameTxt() {
        return (this.name || 'Unknown')
            .toLowerCase()
            .split(' management')
            .join('')
            .split('_')
            .map(bit => (0, startCase_1.default)(bit))
            .join(' ')
            .split('Opsbase')
            .join('OpsBase - ')
            .split('Teamboard')
            .join('Teamboard - ');
    }
}
exports.Feature = Feature;
exports.default = Feature;
